export default function LFP(props: any) {
    return (
        <svg width="46" height="25" viewBox="0 0 46 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 6.21401C1 5.34613 1.70355 4.64258 2.57143 4.64258H18.2857C19.1536 4.64258 19.8571 5.34613 19.8571 6.21401V19.3092C19.8571 20.1771 19.1536 20.8807 18.2857 20.8807H2.57143C1.70355 20.8807 1 20.1771 1 19.3092L1 6.21401Z"
                stroke="black"
                strokeWidth="1.3"
            />
            <path
                d="M4.14282 3.46415C4.14282 3.24718 4.31871 3.07129 4.53568 3.07129H5.8452C6.06217 3.07129 6.23806 3.24718 6.23806 3.46415V4.64272H4.14282V3.46415Z"
                fill="black"
            />
            <path
                d="M14.619 3.46415C14.619 3.24718 14.7949 3.07129 15.0119 3.07129H16.3214C16.5384 3.07129 16.7143 3.24718 16.7143 3.46415V4.64272H14.619V3.46415Z"
                fill="black"
            />
            <path d="M4 10.3574L4 15.3498H7.05603" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.95508 15.6621V10.6697H12.0111" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.95508 13.166H12.0111" stroke="black" strokeWidth="0.9" strokeLinecap="round" />
            <path d="M13.9102 10.6699V15.6623" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M13.9102 10.6699H15.6783C16.3293 10.6699 16.857 11.1977 16.857 11.8487V11.8487C16.857 12.4997 16.3293 13.0274 15.6783 13.0274H13.9102V10.6699Z"
                stroke="black"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
